<template>
    <div>
        <v-flex xs12 sm12 lg12 xl12>
            <v-card>
                <v-toolbar dense color="secondary" dark>
                    <v-toolbar-title>Customers</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-text-field autocomplete="off" aria-autocomplete="none" append-icon="search" v-model="searchUserString" placeholder="Search customers">
                    </v-text-field>
                </v-toolbar>
                <v-layout justify-center>
                    <v-flex xs3 mt-2 ml-2>
                        <v-card elevation="10">
                            <v-card-title primary-title>
                                <div class="title">
                                    {{ Total }}
                                </div>
                                <v-icon size=20>equalizer</v-icon>
                                <v-spacer></v-spacer>
                                <div class="title">
                                    Customer(s)
                                </div>
                            </v-card-title>
                        </v-card>
                    </v-flex>
                    <v-flex xs3 mt-2 ml-2>
                        <v-card color="error --darken-1" elevation="10">
                            <v-card-title primary-title>
                                <div class="title">
                                    {{ TotalInactive }}
                                </div>
                                <v-icon size=20>equalizer</v-icon>
                                <v-spacer></v-spacer>
                                <div class="title">
                                    Inactive Customer(s)
                                </div>
                            </v-card-title>
                        </v-card>
                    </v-flex>
                    <v-flex xs3 mt-2 ml-2>
                        <v-card color="success --darken-2" elevation="10">
                            <v-card-title primary-title>
                                <div class="title">
                                    {{ TotalActive }}
                                </div>
                                <v-icon size=20>equalizer</v-icon>
                                <v-spacer></v-spacer>
                                <div class="title">
                                    Active Customer(s)
                                </div>
                            </v-card-title>
                        </v-card>
                    </v-flex>

                </v-layout>
                <v-layout>
                    <v-flex xs12 sm12 md12 lg12 xl12>
                        <CustomerList :search="searchUserString" />
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </div>
</template>

<script>
    import CustomerList from '@/components/common/customers/customer-list'

    export default {
        data() {
            return {
                TotalActive: 0,
                TotalInactive: 0,
                Total: 0,
                searchUserString: null
            }
        },
        components: {
            CustomerList,
        },
        mounted() {
            let self = this;
            self.FetchData();
        },
        methods: {
            FetchData() {
                let self = this;
                self.get('Customer/Counters')
                    .then(response => {
                        self.TotalActive = response.data.TotalActive;
                        self.TotalInactive = response.data.TotalInactive;
                        self.Total = response.data.TotalUsers;
                    })
                    .catch(error => {

                    })
            }
        }
    }
</script>

<style>

</style>